import SingleTurbineSection7 from './SingleTurbineSection7';
import SingleTurbineSection6 from './SingleTurbineSection6';
import SingleTurbineSection5 from './SingleTurbineSection5';
import SingleTurbineSection4 from './SingleTurbineSection4';
import SingleTurbineSection3 from './SingleTurbineSection3';
import SingleTurbineSection2 from './SingleTurbineSection2';
import SingleTurbineSection1 from './SingleTurbineSection1';

export default function SingleTurbine() {
  return (
    <>
      <SingleTurbineSection1 /> 
      <SingleTurbineSection2 />
      <SingleTurbineSection3 />  
      <SingleTurbineSection4 />  
      <SingleTurbineSection5 />
      <SingleTurbineSection6 />
    </>
  );
}


